<template>
  <div id="diagnostic-section-reports-detail" class="row">
    Это секция выгрузки детализации
  </div>
</template>